
export default {
  className: 'cleaning',
  title: '保洁订单',
  fields: [
    {
      name: 'user',
      disabled: true,
      searchKey: ['nickName', 'phone'],
      render: (record) => {
        return (record && record.user && record.user.nickName) || ''
      },
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
      }
    },
    {
      name: 'room',
      disabled: true,
      note: '所属房间'
    },
    {
      disabled: true,
      name: 'details'
    },
    {
      disabled: true,
      name: 'pictures'
    },
    {
      name: 'isDone',
      width: 120,
      note: '是否完成',
      disabled: true
    }
  ],
  search: [
    {
      name: 'user',
      disabled: false
    },
    'isDone'
  ],
  hooks: {

  },
  action: {
    create: false,
    view: false,
    edit: {
      text: '查看'
    },
    complete: {
      type: 'row',
      text: '完成',
      hidden: ({ record }) => {
        return record && record.isDone
      },
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '您确定此保洁订单已完成了吗？')
        // 更改订单状态
        let cleaning = await vm.$tkParse.put(`/classes/cleaning/${record.objectId}`, {
          isDone: true
        })
        if (cleaning) {
          vm.$notification['success']({
            message: '操作成功',
            description: '此订单已完成'
          })
        }
        vm.refresh()
      }
    }
  }
}
